import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from '#src/components/layouts/InfoLayout.tsx';

const SpecialCredits = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          defaultMessage: 'SPECIAL_CREDIT.md',
        })}
        escapeHtml={false}
      />
    </InfoLayout>
  );
};

export default SpecialCredits;
